/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { DesignContext } from "@adapptio/lib-blueprint";
import { ResourceService } from "../../../resources/ResourceService";
import { useStateWithEvent } from "../../hooks";
import { IReferenceListItem } from "./ReferenceList";

export function getReferenceListData(resourceId: string, resourceService: ResourceService, dCtx: DesignContext) {
	const referencedBy = useStateWithEvent(
		resourceService.onResourceListChange,
		() => resourceService.getReferencedByResourceList(resourceId).map((resource) => ({
			id: resource.id,
			name: resource.descriptor.name,
			resourceType: resource.resourceType,
			basePath: resource.descriptor.basePath,
		} as IReferenceListItem)),
		[ resourceService, resourceId ], true
	);
	
	const dependsOn = useStateWithEvent(
		dCtx.modelChangeEvent,
		() => {
			const refMap = dCtx.getRefsIndex();
			const refIdList = new Set<string>();
	
			for (const type in refMap) {
				for (const refId in refMap[type]) {
					refIdList.add(refId)
				}
			}
	
			return Array.from(refIdList).map((refId) => {
				const resource = resourceService.getResourceById(refId);

				if (!resource) {
					return null;
				}

				return {
					id: resource.id,
					name: resource.descriptor.name,
					resourceType: resource.resourceType,
					basePath: resource.descriptor.basePath,
				};
			}).filter((item) => item !== null) as IReferenceListItem[];
		},
		[ dCtx, resourceService ], true
	);

	return {
		referencedBy,
		dependsOn
	}
}
